export var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["PASSWORD"] = "password";
    InputType["NUMBER"] = "number";
    InputType["DATE"] = "date";
    InputType["DATETIME"] = "datetime-local";
})(InputType || (InputType = {}));
